module.exports = __webpack_public_path__ + "img/designer-logo-fill-02-f5d1848852c402614cdd84387b798c02.55401b93.png";